/* SURE Minimal Premium - Global JS with Effects */

(function() {
  'use strict';

  // ============================================
  // LENIS SMOOTH SCROLL
  // ============================================
  let lenis;
  try {
    lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 2,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    window.stopLenis = () => lenis.stop();
    window.startLenis = () => lenis.start();
  } catch(e) {
    // Lenis not loaded, continue without smooth scroll
  }

  // ============================================
  // HEADER SCROLL BEHAVIOR
  // ============================================
  const header = document.querySelector('[data-header]');
  if (header) {
    let ticking = false;

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          if (window.scrollY > 50) {
            header.classList.add('is-scrolled');
          } else {
            header.classList.remove('is-scrolled');
          }
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  // ============================================
  // HERO PARALLAX EFFECT
  // ============================================
  const heroMedia = document.getElementById('heroMedia');
  const heroContent = document.getElementById('heroContent');
  
  if (heroMedia) {
    let ticking = false;
    
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrollY = window.scrollY;
          const heroHeight = window.innerHeight;
          
          if (scrollY < heroHeight) {
            const parallaxValue = scrollY * 0.4;
            const opacityValue = 1 - (scrollY / heroHeight) * 0.6;
            const scaleValue = 1 + (scrollY / heroHeight) * 0.1;
            
            heroMedia.style.transform = 'translateY(' + parallaxValue + 'px) scale(' + scaleValue + ')';
            heroMedia.style.opacity = Math.max(0.3, opacityValue);
            
            if (heroContent) {
              heroContent.style.transform = 'translateY(' + (scrollY * 0.2) + 'px)';
              heroContent.style.opacity = opacityValue;
            }
          }
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  // ============================================
  // MOBILE MENU
  // ============================================
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const menuClose = document.querySelector('[data-menu-close]');

  if (mobileMenu && menuToggle) {
    menuToggle.addEventListener('click', () => {
      mobileMenu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (window.stopLenis) window.stopLenis();
    });
  }

  if (mobileMenu && menuClose) {
    menuClose.addEventListener('click', () => {
      mobileMenu.classList.remove('is-open');
      document.body.style.overflow = '';
      if (window.startLenis) window.startLenis();
    });
  }

  // ============================================
  // SCROLL ANIMATIONS (Intersection Observer)
  // ============================================
  const animateOnScroll = () => {
    const elements = document.querySelectorAll('[data-animate]');
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    elements.forEach(el => observer.observe(el));
  };

  // Animate product cards on scroll
  const animateProductCards = () => {
    const cards = document.querySelectorAll('.product-card');
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    cards.forEach(card => observer.observe(card));
  };

  animateOnScroll();
  animateProductCards();

  // ============================================
  // PRODUCT PAGE TABS
  // ============================================
  const tabButtons = document.querySelectorAll('[data-tab-button]');
  const tabPanels = document.querySelectorAll('[data-tab-panel]');

  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      const tabName = button.dataset.tabButton;

      tabButtons.forEach(btn => btn.classList.remove('is-active'));
      button.classList.add('is-active');

      tabPanels.forEach(panel => {
        panel.classList.remove('is-active');
        if (panel.dataset.tabPanel === tabName) {
          panel.classList.add('is-active');
        }
      });
    });
  });

  // ============================================
  // PRODUCT IMAGE THUMBNAILS
  // ============================================
  const thumbnails = document.querySelectorAll('[data-thumbnail]');
  const mainImage = document.querySelector('[data-main-image]');

  thumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('click', () => {
      const imageUrl = thumbnail.dataset.imageUrl;
      if (mainImage && imageUrl) {
        mainImage.style.opacity = '0';
        setTimeout(() => {
          mainImage.src = imageUrl;
          mainImage.style.opacity = '1';
        }, 200);
        
        thumbnails.forEach(t => t.classList.remove('is-active'));
        thumbnail.classList.add('is-active');
      }
    });
  });

  // ============================================
  // QUANTITY SELECTORS
  // ============================================
  const quantityMinus = document.querySelector('[data-quantity-minus]');
  const quantityPlus = document.querySelector('[data-quantity-plus]');
  const quantityInput = document.querySelector('[data-quantity-input]');
  const quantityValue = document.querySelector('[data-quantity-value]');

  if (quantityMinus && quantityInput) {
    quantityMinus.addEventListener('click', () => {
      const currentValue = parseInt(quantityInput.value) || 1;
      if (currentValue > 1) {
        quantityInput.value = currentValue - 1;
        if (quantityValue) quantityValue.value = currentValue - 1;
      }
    });
  }

  if (quantityPlus && quantityInput) {
    quantityPlus.addEventListener('click', () => {
      const currentValue = parseInt(quantityInput.value) || 1;
      quantityInput.value = currentValue + 1;
      if (quantityValue) quantityValue.value = currentValue + 1;
    });
  }

  // ============================================
  // VARIANT OPTION BUTTONS
  // ============================================
  const optionButtons = document.querySelectorAll('[data-option-value]');
  
  optionButtons.forEach(button => {
    button.addEventListener('click', () => {
      if (button.disabled) return;
      
      const parent = button.closest('.product-main__option-values');
      if (parent) {
        parent.querySelectorAll('[data-option-value]').forEach(btn => {
          btn.classList.remove('is-selected');
        });
      }
      
      button.classList.add('is-selected');
      
      const ripple = document.createElement('span');
      ripple.classList.add('ripple');
      button.appendChild(ripple);
      setTimeout(() => ripple.remove(), 600);
    });
  });

  // ============================================
  // FAQ ACCORDION
  // ============================================
  const faqToggles = document.querySelectorAll('[data-faq-toggle]');
  
  faqToggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      const item = toggle.closest('.faq__item');
      if (item) {
        document.querySelectorAll('.faq__item.is-open').forEach(openItem => {
          if (openItem !== item) openItem.classList.remove('is-open');
        });
        item.classList.toggle('is-open');
      }
    });
  });

  // ============================================
  // COLLECTION SORT
  // ============================================
  const sortSelect = document.querySelector('[data-sort-select]');
  
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });

    const urlParams = new URLSearchParams(window.location.search);
    const sortBy = urlParams.get('sort_by');
    if (sortBy) {
      sortSelect.value = sortBy;
    }
  }

  // ============================================
  // MAGNETIC BUTTONS (Hover Effect)
  // ============================================
  const magneticButtons = document.querySelectorAll('.hero__button, .editorial__button');
  
  magneticButtons.forEach(button => {
    button.addEventListener('mousemove', (e) => {
      const rect = button.getBoundingClientRect();
      const x = e.clientX - rect.left - rect.width / 2;
      const y = e.clientY - rect.top - rect.height / 2;
      
      button.style.transform = 'translate(' + (x * 0.2) + 'px, ' + (y * 0.2) + 'px)';
    });
    
    button.addEventListener('mouseleave', () => {
      button.style.transform = 'translate(0, 0)';
    });
  });

  // ============================================
  // TEXT REVEAL ANIMATION
  // ============================================
  const revealText = () => {
    const textElements = document.querySelectorAll('[data-reveal-text]');
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    textElements.forEach(el => observer.observe(el));
  };
  
  revealText();

})();
